module.exports = __webpack_public_path__ + "static/media/postcard.30b1bf87.jpg";